import { render, staticRenderFns } from "./BaseListPage.vue?vue&type=template&id=0d592222&scoped=true"
import script from "./BaseListPage.vue?vue&type=script&lang=js"
export * from "./BaseListPage.vue?vue&type=script&lang=js"
import style0 from "./BaseListPage.vue?vue&type=style&index=0&id=0d592222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d592222",
  null
  
)

export default component.exports